document.addEventListener("DOMContentLoaded", function () {
  fetch("https://gimmedeals.myshopify.com/api/2024-01/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "a637bcb5869b3fc0becfcd19afe5ffb6",
    },
    body: JSON.stringify({
      query: `
        {
          collection(handle: "shop-all") {
            products(first: 250) {
              edges {
                node {
                  id
                  title
                  handle
                  tags
                  variants(first: 250) {
                    edges {
                      node {
                        id
                        title
                        price {
                          amount
                          currencyCode
                        }
                        image {
                          url
                        }
                        availableForSale
                        metafield(namespace: "custom", key: "color_swatch") {
                          value
                          reference {
                    ... on Metaobject {
                      fields {
                        key
                        value
                         reference {
                          __typename
                          ... on MediaImage {
                            image {
                              url
                            }
                          }
                        }
                      }
                    }
                  }
                        }
                      }
                    }
                  }
                  featuredImage {
                    url
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }
      `,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      const products = data.data.collection.products.edges.map(
        (edge) => edge.node
      );
      console.log(data.data.collection.products);
      const productContainer = document.getElementById("product-list");

      products.forEach((product) => {
        if (product.tags.includes("homecarousel")) {
          const variants = product.variants.edges.map((edge) => edge.node);
          const homeTags = product.tags.filter((tag) =>
            tag.startsWith("home-")
          );

          if (homeTags.length > 0) {
            homeTags.forEach((homeTag) => {
              let category = homeTag.replace("home-", "");
              let defaultVariant = variants[0];
              let price = "$" + parseInt(defaultVariant.price.amount);

              const variantLinks = variants
                .map((variant, index) => {
                  let colorTitle = ""; // Default empty
                  let colorImage = ""; // Default empty

                  // Ensure metafield and reference exist before accessing fields
                  if (
                    variant.metafield &&
                    variant.metafield.reference &&
                    variant.metafield.reference.fields
                  ) {
                    const fields = variant.metafield.reference.fields;

                    // Extract title and image safely
                    const titleField = fields.find(
                      (field) => field.key === "title"
                    );
                    const imageField = fields.find(
                      (field) => field.key === "image"
                    );

                    colorTitle = titleField ? titleField.value : "";

                    // Check if imageField contains a reference to MediaImage
                    if (
                      imageField &&
                      imageField.reference &&
                      imageField.reference.image
                    ) {
                      colorImage = imageField.reference.image.url; // Get actual image URL
                    }
                  }

                  return `
    <a href="#" 
       class="variant-link ${index === 0 ? "active" : ""}"
       data-variant-id="${variant.id}"
       data-image="${
         variant.image ? variant.image.url : product.featuredImage.url
       }"
       data-price="${variant.price.amount} ${variant.price.currencyCode}"
       data-available="${variant.availableForSale}"
       data-color="${colorTitle}"
       data-color-image="${colorImage}"
    >
     
      ${
        colorImage
          ? `<img src="${colorImage}" alt="${colorTitle}" class="color-swatch">`
          : ""
      }
    </a>
  `;
                })
                .join("");

              const variantId = defaultVariant.id.split("/").pop(); // Extracts numeric ID
              const productId = product.id.split("/").pop(); // Extracts numeric ID
              const productHTML = `
              <div class="carousel-item product-item" data-category="${category}" data-product-id="${
                product.id
              }">
                <div class="productimage">
                <a href="https://gimmebeauty.com/products/${
                  product.handle
                }">
                  <img src="${
                    defaultVariant.image
                      ? defaultVariant.image.url
                      : product.featuredImage.url
                  }" 
                       alt="${product.title}"
                       class="product-image"></a>
                </div>
                <div class="proconwrap-car">
                <div class="proconinner-car">
                <h3 class="caroprotit">${product.title}</h3>
                <div class="yotpo bottomLine" data-product-id="${productId}"></div>
                </div>              
                <div class="variant-links">
                  ${variantLinks}
                </div>
                </div>
                <div class="caroprobtn">
                <a class="button" href="https://gimmebeauty.com/products/${
                  product.handle
                }?variant=${variantId}" 
                   class="add-to-cart-link"
                   ${!defaultVariant.availableForSale ? "disabled" : ""}
                   data-producthandle="${product.handle}">

                   ${
                     defaultVariant.availableForSale ? "Add to Bag" : "Sold Out"
                   } - ${price}
                   <div class="loading__spinner hidden">
  <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
</div>
                </a>
                </div>
              </div>
            `;
              productContainer.innerHTML += productHTML;
            });
          } else {
            // Similar code for uncategorized products...
          }
        }
      });

      // Add event listeners for variant links
      document.querySelectorAll(".variant-link").forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const productItem = this.closest(".product-item");

          // Remove active class from all variant links in this product
          productItem.querySelectorAll(".variant-link").forEach((link) => {
            link.classList.remove("active");
          });

          // Add active class to clicked variant
          this.classList.add("active");

          const productImage = productItem.querySelector(".product-image");
          const addToCartLink = productItem.querySelector(".add-to-cart-link");
          const priceElement = productItem.querySelector(".price");

          // Update image
          productImage.src = this.dataset.image;

          // Update price
          priceElement.textContent = `Price: ${this.dataset.price}`;

          // Update add to cart link
          addToCartLink.href = `/cart/add?id=${this.dataset.variantId}&quantity=1`;

          // Update availability
          const isAvailable = this.dataset.available === "true";
          if (isAvailable) {
            addToCartLink.textContent = "Add to Cart";
            addToCartLink.removeAttribute("disabled");
          } else {
            addToCartLink.textContent = "Sold Out";
            addToCartLink.setAttribute("disabled", "");
          }
        });
      });
    })
    .catch((error) => console.error("Error fetching products:", error));
});

/* Carousel Code */
window.addEventListener("load", function () {
  setTimeout(function () {
    const carousel = document.querySelector(".carousel");
    const carouselItems = document.querySelectorAll(".carousel-item");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");
    const filterBtns = document.querySelectorAll(".filter-btn");
    const paginationContainer = document.getElementById("pagination");
    let currentIndex = 0;
    let visibleItems = [];
    let itemsToShow = getItemsToShow();

    // Touch handling variables
    let touchStartX = 0;
    let touchEndX = 0;
    let currentTranslate = 0;
    let isDragging = false;
    let startTranslate = 0;
    const minSwipeDistance = 50;

    function getItemsToShow() {
      if (window.innerWidth <= 450) {
        return 1;
      } else if (window.innerWidth <= 1024) {
        return 2;
      } else {
        return 4;
      }
    }

    // Add touch event listeners
    carousel.addEventListener("touchstart", handleTouchStart);
    carousel.addEventListener("touchmove", handleTouchMove);
    carousel.addEventListener("touchend", handleTouchEnd);

    function handleTouchStart(e) {
      touchStartX = e.touches[0].clientX;
      isDragging = true;
      startTranslate = currentTranslate;
      carousel.style.transition = "none";

      const transform = window
        .getComputedStyle(carousel)
        .getPropertyValue("transform");
      const matrix = new DOMMatrix(transform);
      currentTranslate = matrix.m41;
    }

    function handleTouchMove(e) {
      if (!isDragging) return;

      const currentX = e.touches[0].clientX;
      const diff = currentX - touchStartX;

      // Apply the translation with boundaries
      const maxTranslate = 0;
      const minTranslate =
        -(visibleItems.length - 1) * (visibleItems[0].offsetWidth + 15);
      let newTranslate = currentTranslate + diff;

      // Add resistance at boundaries
      if (newTranslate > maxTranslate) {
        newTranslate = maxTranslate + (newTranslate - maxTranslate) * 0.3;
      } else if (newTranslate < minTranslate) {
        newTranslate = minTranslate + (newTranslate - minTranslate) * 0.3;
      }

      carousel.style.transform = `translateX(${newTranslate}px)`;
    }

    function handleTouchEnd(e) {
      if (!isDragging) return;

      isDragging = false;
      touchEndX = e.changedTouches[0].clientX;
      const swipeDistance = touchEndX - touchStartX;

      carousel.style.transition = "transform 0.3s ease-out";

      if (Math.abs(swipeDistance) >= minSwipeDistance) {
        if (swipeDistance > 0 && currentIndex > 0) {
          currentIndex--;
        } else if (
          swipeDistance < 0 &&
          currentIndex < getMaxIndex()
        ) {
          currentIndex++;
        }
      }

      showSlide(currentIndex);
    }

    function getMaxIndex() {
      const isMobile = window.innerWidth <= 450;
      return isMobile
        ? visibleItems.length - 1
        : Math.ceil(visibleItems.length / itemsToShow) - 1;
    }

    function updateVisibleItems() {
      visibleItems = Array.from(carouselItems).filter(
        (item) => item.style.display !== "none"
      );
      
      itemsToShow = getItemsToShow();
      // Add peek-through effect on mobile
      if (window.innerWidth <= 450) {
        visibleItems.forEach((item) => {
          item.style.width = "calc(100% - 60px)"; // Make items slightly smaller to show next
          item.style.margin = "0 15px"; // Add spacing between items
        });
      } else {
        visibleItems.forEach((item) => {
          item.style.width = ""; // Reset to default width
          item.style.margin = ""; // Reset to default margin
        });
      }

      createPaginationDots();
      updateButtonStates();
    }

    function showSlide(index) {
      if (visibleItems.length === 0) return;
      
      const itemWidth = visibleItems[0].offsetWidth + 15; // width + gap
      const isMobile = window.innerWidth <= 450;

      let translateX;
      
      if (isMobile) {
        // For mobile, move one item at a time
        translateX = index * itemWidth;
      } else {
        // For desktop, move by groups of itemsToShow
        const startIndex = index * itemsToShow;
        translateX = startIndex * itemWidth;
      }

      currentTranslate = -translateX;
      carousel.style.transform = `translateX(${currentTranslate}px)`;

      updateActivePaginationDot();
      updateButtonStates();
    }

    function updateButtonStates() {
      const maxIndex = getMaxIndex();

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;

      prevBtn.classList.toggle("disabled", currentIndex === 0);
      nextBtn.classList.toggle("disabled", currentIndex >= maxIndex);
    }

    function createPaginationDots() {
      paginationContainer.innerHTML = "";
      const totalPages = getMaxIndex() + 1;

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement("div");
        dot.classList.add("pagination-dot");
        dot.dataset.page = i;
        dot.addEventListener("click", () => {
          currentIndex = i;
          showSlide(currentIndex);
        });
        paginationContainer.appendChild(dot);
      }
      updateActivePaginationDot();
    }

    function updateActivePaginationDot() {
      const dots = document.querySelectorAll(".pagination-dot");
      dots.forEach((dot) => dot.classList.remove("active"));
      const activeDot = document.querySelector(
        `.pagination-dot[data-page="${currentIndex}"]`
      );
      if (activeDot) activeDot.classList.add("active");
    }

    nextBtn.addEventListener("click", () => {
      const maxIndex = getMaxIndex();

      if (currentIndex < maxIndex) {
        currentIndex++;
        showSlide(currentIndex);
      }
    });

    prevBtn.addEventListener("click", () => {
      if (currentIndex > 0) {
        currentIndex--;
        showSlide(currentIndex);
      }
    });

    filterBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        filterBtns.forEach((button) => button.classList.remove("btnactive"));
        btn.classList.add("btnactive");
        const category = btn.dataset.category;
        carouselItems.forEach((item) => {
          if (category === "all" || item.dataset.category === category) {
            item.style.display = "block";
          } else {
            item.style.display = "none";
          }
        });
        currentIndex = 0;
        updateVisibleItems();
        showSlide(currentIndex);
      });
    });

    window.addEventListener("resize", () => {
      itemsToShow = getItemsToShow();
      updateVisibleItems();
      // Ensure currentIndex is valid after resize
      const maxIndex = getMaxIndex();
      currentIndex = Math.min(currentIndex, maxIndex);
      showSlide(currentIndex);
    });

    // Add smooth transition CSS
    carousel.style.transition = "transform 0.3s ease-out";

    // Initial setup
    updateVisibleItems();
  }, 1000);
});

/* To Load New Products */
window.addEventListener("load", function () {
  setTimeout(() => {
    document.getElementById("newpro").click();
  }, 1500);
});

 document.querySelectorAll('.caroprobtn .button').forEach(button => {
    button.addEventListener('click', function(e) {
      // Remove hidden class from spinner
      const spinner = this.querySelector('.loading__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }
      
      // Optional: prevent default link behavior if you want to show spinner first
      // e.preventDefault();
    });
  });